import { Alert } from '@mui/material';
import PropTypes from 'prop-types';
import { TransactionStatus } from 'enums';
import { getMessageFromStatus } from './getMessageFromStatus';
import { getSeverityFromStatus } from './getSeverityFromStatus';

const SubmittionStatus = ({ status }) => {
    return (
        <Alert severity={getSeverityFromStatus(status)} sx={{ cursor: 'pointer', mb: 2 }}>
            {getMessageFromStatus(status)}
        </Alert>
    );
};

SubmittionStatus.propTypes = {
    status: PropTypes.oneOf(Object.values(TransactionStatus)).isRequired
};

export default SubmittionStatus;
